import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { fmtTime } from "../../lib/time";
import { fmtBought } from "../../lib/surveyFmt";
import { toast } from "sonner";

export default function PromoterSurveys() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api
      .get("/promoter/surveys")
      .then((r) => setRows(r.data))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
          This shift
        </div>
        <h1 className="font-display font-semibold text-3xl tracking-tight">Logged surveys</h1>
      </div>
      {rows.length === 0 ? (
        <div className="glass-panel p-6 text-center text-sm text-neutral-500">
          No surveys logged yet on this shift.
        </div>
      ) : (
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.id} className="glass-panel p-4" data-testid={`survey-row-${r.id}`}>
              <div className="flex justify-between items-start">
                <div className="font-display font-bold">{r.customer_nationality}</div>
                <div className="font-mono text-xs text-neutral-500">
                  {fmtTime(r.created_at)}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2 text-sm">
                <div>
                  <span className="text-neutral-500">Heard:</span> {r.heard_about_ubbs}
                </div>
                <div>
                  <span className="text-neutral-500">Current:</span> {r.current_product}
                </div>
                <div className="col-span-2">
                  <span className="text-neutral-500">Bought:</span>{" "}
                  {fmtBought(r)}
                </div>
                <div>
                  <span className="text-neutral-500">Nicotine:</span> {r.nicotine_level}
                </div>
                <div>
                  <span className="text-neutral-500">Flavor:</span> {r.flavor || "—"}
                </div>
              </div>
              {r.feedback && (
                <div className="text-sm mt-2 text-neutral-700 border-t border-slate-200/50 pt-2">
                  "{r.feedback}"
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
